<template>
  <div>
    <b-table
      class="tab-b"
      :items="dataNV"
      :fields="fields"
      :select-mode="selectMode"
      ref="selectableTable"
      no-select-on-click
      responsive="sm"
    >
      <template v-slot:cell(actions)="row">
        
          <b-row>
            <b-col cols="6">
              <b-button
                size="sm"
                @click="selectRowData(row.index)"
                class="mr-1 btn-rounded-orange border-none"
                >SELECCIONAR
              </b-button>
            </b-col>
            <b-col cols="6">
              <b-button
                size="sm"
                @click="deleteSelectedRow(row.index)"
                class="mr-1 btn-rounded-red border-none"
                v-b-tooltip.hover
                title="Ver detalle"
                >ELIMINAR
              </b-button>
            </b-col>
          </b-row>
        
      </template>
    </b-table>
  </div>
</template>
<script>
export default {
  name: "TableDetails",
  data() {
    return {
      fields: [
        { key: "selected", label: "  " },
        { key: "skuService", label: "SKU Servicio" },
        { key: "descriptionSku", label: "Descripción servicio" },
        { key: "quantity", label: "Cantidad" },
        { key: "skuProduct", label: "SKU Producto" },
        { key: "descriptionSkuProduct", label: "Descripción producto" },
        { key: "actions", label: "" },
      ],
      selectMode: "single",
    };
  },
  props: {
    dataNV:{
      type:Array,
      require:true
    }
  },
  methods: {
    selectRowData(index) {
      this.$emit("rowDetailelected", index);
    },
    deleteSelectedRow(index) {
      this.$emit("deleteRow", index);
    },
  },
};
</script>
<style scoped>
</style>